import React, { Component } from "react";

import { Modal, Table, Header, Item } from "semantic-ui-react";


import ApprovedReimbursementItem from "./ApprovedReimbursementItem";

import { requestClosePaymentModal } from "../actions/reimbursements";

import { connect } from "react-redux";

import * as moment from 'moment';

class PaymentModal extends Component {
  render() {
    const props = this.props;
    const payment = props.payment;
    return (
      <Modal
        onClose={props.onClose}
        open={props.open}
        closeIcon={true}
        centered={false}
      >
        <Modal.Header>${payment.amount} payment for { payment.paid_to.name }.</Modal.Header>
        <Modal.Content>
          <style>{`
                    .heightFix, .heightFix > img {
                        margin-bottom: 1em;
                    }
                `}</style>
          <Modal.Description>
            <Header dividing>Reimbursements</Header>
            <Item.Group>
              {payment.reimbursements.map((r, i) => (
                <ApprovedReimbursementItem reimbursement={r} key={r.uuid} />
              ))}
            </Item.Group>
            <Header dividing>Details</Header>
              <Table definition>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>Payer</Table.Cell>
                    <Table.Cell>{payment.payer}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Paid to</Table.Cell>
                    <Table.Cell>{payment.paid_to.name}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Amount</Table.Cell>
                    <Table.Cell>${ payment.amount }</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Paid via</Table.Cell>
                    <Table.Cell style={{ textTransform: "capitalize" }}>
                      {payment.kind}
                    </Table.Cell>
                  </Table.Row>
                  { payment.kind === 'check' && (
                    <Table.Row>
                      <Table.Cell>
                        Check #
                      </Table.Cell>
                      <Table.Cell>{payment.check_number ? payment.check_number : "Not provided."}</Table.Cell>
                    </Table.Row>
                  )}
                  <Table.Row>
                    <Table.Cell>Timestamp</Table.Cell>
                    <Table.Cell>
                      {moment(payment.created_at).format("llll")}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            <Header dividing>Notes</Header>
            { payment.notes && (<p>
              {payment.notes}
            </p>)}
            { !payment.notes && (<p style={{ color: '#777', fontStyle: 'italic' }}>
              There are no notes to show.
            </p>)}
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(requestClosePaymentModal())
});

export default connect(
  null,
  mapDispatchToProps
)(PaymentModal);



// WEBPACK FOOTER //
// ./frontend/src/components/PaymentModal.js